/**
 * @fileOverview X Axis
 */

/** Define of XAxis props */
export var XAxis = function XAxis() {
  return null;
};
XAxis.displayName = 'XAxis';
XAxis.defaultProps = {
  allowDecimals: true,
  hide: false,
  orientation: 'bottom',
  width: 0,
  height: 30,
  mirror: false,
  xAxisId: 0,
  tickCount: 5,
  type: 'category',
  domain: [0, 'auto'],
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: false,
  scale: 'auto',
  reversed: false,
  allowDuplicatedCategory: true
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/recharts/es6/cartesian/XAxis.js
// module id = 257
// module chunks = 0